module.exports = __webpack_public_path__ + "static/cainflowers-ea3e88eb1bfd4efaf56a8af4a0d0ad44.png";